import { render } from "./NotFoundComponent404.vue?vue&type=template&id=32757130&scoped=true"
import script from "./NotFoundComponent404.vue?vue&type=script&lang=ts"
export * from "./NotFoundComponent404.vue?vue&type=script&lang=ts"

import "./NotFoundComponent404.vue?vue&type=style&index=0&id=32757130&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-32757130"

export default script